var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-header"},[_c('i',{staticClass:"icon-vertice"}),_vm._v("\n  extreme.cloud\n")])}]

export { render, staticRenderFns }